module.exports = __webpack_public_path__ + "static/media/intro_gold@2x.67036642.png";